module.exports = __webpack_public_path__ + "static/media/marketplace-zapier-icon.6ea9eb2a.svg";